import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import toast from './toast';

export const toDateRangeText = (start_time, end_time) => {
  const start = dayjs(start_time).format('M.D');
  let end = dayjs(end_time).format('M.D HH:mm');
  if (end.includes('23:59')) end = end.replace('23:59', '24:00');
  // const format = "YYYY.MM.DD HH:mm:ss";
  return start + ' - ' + end;
};

export function toFloat(float, point = 2) {
  float = Number(float);
  if (isNaN(float) || float === Infinity || float === -Infinity) return 0;
  return Number(float.toFixed(point));
}

export function toPercent(num, point = 2) {
  const number = Number(num);
  if (isNaN(number) || number === Infinity || number === -Infinity) return '-';
  return `${(number * 100).toFixed(point)}%`;
}

// 转化成千位百分比符字符串
export function toBigPercent(value, point = 2) {
  const pValue = toPercent(value, point).slice(0, -1);
  if (pValue) {
    return `${toBigNumber(pValue)}%`;
  }
  return '-';
}

// 转化成千位符字符串
export function toBigNumber(value) {
  if (value == null) return value;
  const regex = /(\d)(?=(\d{3})+$)/g;
  const strValue = String(value);
  if (strValue.indexOf('.') >= 0) {
    const strs = strValue.split('.');
    return `${strs[0].replace(regex, '$1,')}.${strs[1]}`;
  }
  return strValue.replace(regex, '$1,');
}

export function toBigNumberWithUnit(value) {
  if (value == null) return null;
  if (value < 1000) return value;
  return toBigNumber(toFloat(value / 1000, 1)) + 'K';
}

export function shareUrl(msg) {
  try {
    // 将当前url复制到剪贴板
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    toast(msg || '分享成功');
  } catch (err) {
    console.error(err);
    toast('分享失败');
  }
}

export function toAigc(isBlank = true) {
  const url =
    process.env.VUE_APP_ENV === 'production'
      ? 'https://aigc.mgtv.com'
      : 'http://aigc-test.mgtv.com';
  if (isBlank === false) {
    window.location.href = url;
  } else {
    window.open(url);
  }
}

export function toCreateAigc(isBlank = true) {
  const url =
    process.env.VUE_APP_ENV === 'production'
      ? 'https://aigc.mgtv.com'
      : 'http://aigc-test.mgtv.com';
  if (isBlank === false) {
    window.location.href = url;
  } else {
    window.open(url);
  }
}

function arrayBufferToWordArray(arrayBuffer) {
  const uint8Array = new Uint8Array(arrayBuffer);
  const words = [];

  for (let i = 0; i < uint8Array.length; i += 1) {
    words[i >>> 2] |= uint8Array[i] << (24 - (i % 4) * 8);
  }

  return CryptoJS.lib.WordArray.create(words, uint8Array.length);
}

// export async function getFileMd5(file) {
//   const arrayBuffer = await file.arrayBuffer();
//   const wordArray = arrayBufferToWordArray(arrayBuffer);
//   const digest = CryptoJS.MD5(wordArray);

//   return {
//     md5Hex: digest.toString(CryptoJS.enc.Hex),
//     md5Base64: digest.toString(CryptoJS.enc.Base64),
//   };
// }

// 大文件版本
export async function getFileMd5(file) {
  // Define chunk size (2MB) to ensure memory usage stays low
  const chunkSize = 2 * 1024 * 1024;
  const chunks = Math.ceil(file.size / chunkSize);

  // Create a progressive MD5 hasher
  const md5Hasher = CryptoJS.algo.MD5.create();

  for (let i = 0; i < chunks; i++) {
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, file.size);

    // Slice the file to get a chunk
    const blob = file.slice(start, end);

    // Read the chunk as ArrayBuffer
    const arrayBuffer = await blob.arrayBuffer();

    // Convert chunk to WordArray (reusing the existing helper)
    const wordArray = arrayBufferToWordArray(arrayBuffer);

    // Update the hash with the current chunk
    md5Hasher.update(wordArray);
  }

  // Finalize the hash
  const digest = md5Hasher.finalize();

  return {
    md5Hex: digest.toString(CryptoJS.enc.Hex),
    md5Base64: digest.toString(CryptoJS.enc.Base64),
  };
}

/**
 * 节流函数
 * @param {Function} func - 需要节流的函数
 * @param {number} wait - 等待时间（毫秒）
 * @returns {Function} 节流后的函数
 */
export function throttle(func, wait) {
  let timeout = null;
  let previous = 0;

  return function (...args) {
    const now = Date.now();
    const remaining = wait - (now - previous);

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(this, args);
    } else if (!timeout) {
      timeout = setTimeout(() => {
        previous = Date.now();
        timeout = null;
        func.apply(this, args);
      }, remaining);
    }
  };
}

/**
 * 防抖函数
 * @param {Function} func - 需要防抖的函数
 * @param {number} wait - 等待时间（毫秒）
 * @param {boolean} immediate - 是否立即执行
 * @returns {Function} 防抖后的函数
 */
export function debounce(func, wait, immediate = false) {
  let timeout = null;

  return function (...args) {
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(this, args);
      }
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(this, args);
    }
  };
}
